export class ClasseProduto {
    Id: number;
    Descricao:string = "";
    EmpresaId: number;
}
